import { lazy } from 'react'
import { FileBarChart } from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'
const ClientReports = lazy(() => import('./ClientReports'))
export const clientReportRoutes: FeatureRoute[] = [{ path: 'client-reports', element: <ClientReports /> }]
export const clientReportNav: NavItem[] = [{ to: '/client-reports', label: 'Client reports', icon: FileBarChart, section: 'Sales' }]
